/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IMemberEntity } from "src/client/react/src/staffhub/sh-models";
import { mutatorAction } from "satcheljs";
import schedulesViewStateStore from "../store/store";

/**
 * Add/remove a member to/from the members filter list
 * @param member the member
 * @param selected whether the member is selected, true to add to the filter list, false to remove from the filter list
 */
export const setMemberFilter = mutatorAction(
    "setMemberFilter",
    (member: IMemberEntity, selected: boolean) => {
        const { filteredMembers } = schedulesViewStateStore();

        if (!selected && filteredMembers.has(member.id)) {
            filteredMembers.delete(member.id);
        } else if (selected && !filteredMembers.has(member.id)) {
            filteredMembers.set(member.id, member);
        }
    }
);